module.exports = __webpack_public_path__ + "img/ASC_SORT.fd8311c7.svg";